
import { mealCompositionCrudService } from "./mealCompositionCrudService";
import { mealCompositionRecipeService } from "./mealCompositionRecipeService";

/**
 * Consolidated service for creating, updating and deleting meal compositions
 * This service combines CRUD operations and recipe management
 */
export const mealCompositionMutationService = {
  // CRUD operations
  createMealComposition: mealCompositionCrudService.createMealComposition,
  updateMealComposition: mealCompositionCrudService.updateMealComposition,
  deleteMealComposition: mealCompositionCrudService.deleteMealComposition,
  
  // Recipe management
  addRecipeToComposition: mealCompositionRecipeService.addRecipeToComposition,
  removeRecipeFromComposition: mealCompositionRecipeService.removeRecipeFromComposition,
};
